import * as XLSX from 'xlsx';
import type { DadosRelatorioItem } from '@/services/Relatorios';

export function exportToExcel(
  data: DadosRelatorioItem[],
  fileName: string,
  colunasMonetarias?: Set<string>
) {
  const dadosFormatados = data.map(item => {
    const formatado: Record<string, unknown> = {};
    for (const [chave, valor] of Object.entries(item)) {
      if (typeof valor === 'number' && colunasMonetarias?.has(chave)) {
        formatado[chave] = valor.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } else {
        formatado[chave] = valor;
      }
    }
    return formatado;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(dadosFormatados);

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
  XLSX.writeFile(workbook, fileName);
}

export function formatExcelFileName(nomeRelatorio: string): string {
  const dataHora = new Date()
    .toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
    .replace(/[/:]/g, '-')
    .replace(', ', '-');

  return `${nomeRelatorio} - ${dataHora}-relatorio.turboSPED.xlsx`;
}
